import Card from '@components/card/card';

import './stepHeader.scss';

const StepHeader = ({ text, subtext, children, ...props }) => (
  <div className='step-header-container' {...props}>
    <h2 className='step-header'>{text}</h2>
    {(subtext || children) && (
      <Card>
        <Card.Body>
          {subtext && <div className='step-header-subtext'>{subtext}</div>}
          {children}
        </Card.Body>
      </Card>
    )}
  </div>
);

export default StepHeader;
